import BaseProjectCard from '../BaseProjectCard/BaseProjectCard';
import IQuestionnaire from '../../../types/survey/IQuestionnaire';
import styles from './QuestionnaireCard.module.scss';
import StopwatchFill from 'react-bootstrap-icons/dist/icons/stopwatch-fill';

type QuestionnaireCardProps = {
    item: IQuestionnaire;
    onClick: (item: IQuestionnaire) => void;
    disabled?: boolean;
};

export default function QuestionnaireCard(props: QuestionnaireCardProps) {
    const { item, onClick, disabled } = props;
    const {
        name,
        internalName,
        type,
        subtype,
        completedQuestionsCount,
        questionsCount,
        timed,
        timeToFill,
    } = item;

    return (
        <BaseProjectCard
            name={name}
            iconName={internalName}
            type={type}
            subtype={subtype}
            onClick={handleClick(item)}
            disabled={disabled}
        >
            <div className={styles.content}>
                <div>
                    {completedQuestionsCount}/{questionsCount}
                </div>
                <div>
                    {timed && (
                        <span className={styles.content__time__icon}>
                            <StopwatchFill />
                        </span>
                    )}
                    <span className={styles.content__time__info}>
                        {timeToFill}
                    </span>
                </div>
            </div>
        </BaseProjectCard>
    );

    function handleClick(questionnaire: IQuestionnaire) {
        return () => onClick(questionnaire);
    }
}
